import React, { Component } from 'react';
import { Route, Switch, Redirect, Router } from 'react-router-dom';
import history from '../history/history';
import InvestmentDashboard from '../Epics/Investments/Pages/InvestmentDashboard/InvestmentDashboard';
import MyAccount from '../Epics/MyAccounts/Pages/MyAccount/MyAccount';
import MyProfile from '../Epics/MyAccounts/Pages/MyProfile/MyProfile';
import EditProfile from '../Epics/MyAccounts/Components/EditProfile/EditProfile';
import InvestmentOptionDetails from '../Epics/Investments/Pages/InvestmentOptionDetails/InvestmentOption';
import RecommendGrantPage from '../Epics/Grants/Pages/RecommendGrant/RecommendGrantPage';
import GrantsActivity from '../Epics/Grants/Pages/GrantsActivity/GrantsActivity';
import NpaSetUpAccount from '../Epics/NPA/Pages/Step1Setup/NpaSetUpAccount';
import EditAdvisor from '../Epics/MyAccounts/Components/Step1Setup/NpaSetUpAccount';
import EditSuccession from '../Epics/MyAccounts/Components/Step2LegacyOptions/Step2Main';
import { NotFoundComponent } from '../CommonComponents/GlobalErrors';
import SACComponent from '../Epics/Grants/Pages/SuggestACharity/Manager';
import GrantAgreementLandingPage from '../Epics/Grants/Pages/GrantAgreement/GrantAgreementLandingPage';
import GrantAgreementFlow from '../Epics/Grants/Pages/GrantAgreement/GrantAgreementFlow';
import GrantAgreementConfirmation from '../Epics/Grants/Pages/GrantAgreement/ConfirmationPage';
import ViewInvestmentExchangeActivity from '../Epics/Investments/Pages/ViewInvestmentExchangeActivity/ViewInvestmentExchangeActivity';
import AccountCreated from '../Epics/NPA/Pages/AccountCreated/AccountCreated';
import ContributeLater from '../Epics/NPA/Pages/ContributeLater/ContributeLater';
import AccountSummary from '../Epics/AccountSummary/Pages/AccountSummary';
import { RoutesContainer } from '../CommonComponents/commonStyles';
import ProductTour from '../CommonComponents/Header/Component/ProductTour/ProductTour';
import MessagesPage from '../Epics/Messaging/MessagesPage';
import MakeAContribution from '../Epics/Contributions/Pages/MakeAContribution/MakeAContribution';
import DocumentCentre from '../Epics/DocumentCentre/Pages/DocumentCentre';
import ContributionActivity from '../Epics/Contributions/Pages/ContributionActivity/ContributionActivity';
import ViewContribution from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/ViewContribution';
import AssetheldMF from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/AssetheldMF';
import FundingInstructionss from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/FundingInstructions';
import AssetOutsideMF from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/AssetOutsideMF';
import AssetheldSecurity from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/AssetheldSecurity';
import AssetheldSecuritySLOA from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/AssetheldSecuritySLOA';
import AssetheldMFSLOA from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/AssetheldMFSLOA';
import AssetsOutsideSecurity from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/AssetsOutsideSecurity';
import StockCertificate from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/StockCertificate';
import Wire from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/Wire';
import Check from '../Epics/Contributions/Pages/ContributionActivity/Components/ViewContribution/Components/FundingInstructions/Check';
import AdminSearch from '../Epics/AdminSearch/Pages/AdminSearch';
import { adminUsage, financialAdvisorUsage } from '../utils/commonUtil';
import ContributionsDashboard from '../Epics/Contributions/Pages/ContributionsDashboard/ContributionsDashboard';
import GrantsDashboard from '../Epics/Grants/Pages/GrantsDashboard/GrantsDashboard';
import InviteParties from '../Epics/MyAccounts/Components/InviteInterestedParties/InviteParties';
import TIFFRecommendAnExchangeConnector from '../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/TIFFRecommendAnExchangeConnector';
import HowItWorks from '../Epics/Grants/Pages/HowItWorks/HowItWorks';
import ViewAndEditTiffFrom from '../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/ViewAndEditFromConnector';
import ViewAndEditTiffInto from '../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/ViewAndEditIntoConnector';
import EditTIFF from '../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/EditTIFFConnector';
import TransactionSummary from "../Epics/TransactionSummary/Pages/TransactionSummary";
import OtherTransactionDetails from "../Epics/TransactionSummary/Pages/OtherTransactionDetails";
import CsrMainComponent from "../CSR/CsrMainComponent";
import ViewGrantDetails from '../Epics/Grants/Pages/RecommendGrant/ViewGrantDetails';
import ContributionConfirmation from '../Epics/Contributions/Pages/MakeAContribution/Components/ContributionConfirmation/Confirmation';
import FinancialAdvisor from '../Epics/FinancialAdvisor/FinancialAdvisor';
import EditGrantPage from '../Epics/Grants/Pages/RecommendGrant/EditGrantPage';
import RecommendGrantConfirmationPage from '../Epics/Grants/Pages/RecommendGrant/RecommendGrantConfirmationPage';
import RecommendAnExchangeNew from '../Epics/Investments/Pages/RecommendAnExchangeNew';
import TiffNotEligibleForm from '../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/TiffNotEligibleFormConnector';
import FindCharity from '../Epics/Grants/Pages/RecommendGrant/FindCharity';
import ViewGrantAgreement from '../Epics/Grants/Pages/GrantAgreement/ViewGrantAgreement';
import { isGeminiUser } from '../utils/sessionUtil';

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      changedHeaderHeight: null
    };
  }

  updateHeaderHeight = height => {
    this.setState({ changedHeaderHeight: height });
  };

  tourHeightChanged = height => {
    this.updateHeaderHeight(height);
  };

  render() {
    const { userSessionLoaded } = this.props;
    return (
      <>
        {(isGeminiUser() || !adminUsage.isAdminPage) && userSessionLoaded && (
          <ProductTour
            id="btnProductTour"
            tourHeightChanged={this.tourHeightChanged}
            isOpen={false}
            userSessionLoaded={userSessionLoaded}
          />
        )}
        <RoutesContainer headerHeight={this.state.changedHeaderHeight}>
          <Router history={history}>
            <Switch>
              <Route exact path='/' component={AccountSummary} />
              <Route exact path='/AdminSearch' component={AdminSearch} />
              <Route
                exact
                path='/investments/exchange-activity'
                component={ViewInvestmentExchangeActivity}
              />
             
              <Route exact path='/investments' component={InvestmentDashboard} />
              <Route exact path='/investments/details' component={InvestmentOptionDetails} />
              <Route
                path='/investments/recommend-an-exchange'
                component={RecommendAnExchangeNew}
              />
              <Route
                path='/investments/recommend-an-exchange-tiff'
                component={TIFFRecommendAnExchangeConnector}
              />
              <Route
                path='/investments/recommend-an-exchange-tiff/allocate'
                component={TIFFRecommendAnExchangeConnector}
              />
              <Route exact path='/my-account' component={MyAccount} />
              <Route
                exact
                path='/my-account/transaction-summary'
                component={TransactionSummary}
              />
              <Route
                exact
                path='/my-account/other-transaction'
                component={OtherTransactionDetails}
              />
              {/* this order of /grants/recommend/confirm and /grants/recommend/confirm is imp,
               please do not change */}
              <Route
                path='/grants/recommend/confirm'
                component={RecommendGrantConfirmationPage}
                exact
              />
              <Route path='/grants/recommend' component={RecommendGrantPage} />
              <Route path='/grants/activity/edit' component={EditGrantPage} />
              <Route exact path='/my-profile' component={MyProfile} />
              <Route exact path='/grants/activity' component={GrantsActivity} />
              <Route exact path='/suggest-a-charity' component={SACComponent} />
               {/* Initial starting page of Open additional account is /account-information
               So, if a user by mistake lands to page /open-an-additional-account, will be redirected to the initial page */}
              <Route exact path='/open-an-additional-account' render={() => (<Redirect to="/open-an-additional-account/account-information/" />)} />
              <Route path='/open-an-additional-account/account-information/' component={NpaSetUpAccount} exact />
              <Route path='/open-an-additional-account/legacy-options/' component={NpaSetUpAccount} exact />
              <Route path='/open-an-additional-account/review/' component={NpaSetUpAccount} exact />
              <Route path='/my-account/edit' component={EditAdvisor} exact />
              <Route path='/my-account/edit-legacy-options' component={EditSuccession} exact />
              <Route
                exact
                path='/grants/agreement'
                component={GrantAgreementLandingPage}
              />
              <Route
                exact
                path='/grants/grant-agreement/confirm'
                component={GrantAgreementConfirmation}
              />
              <Route
                path='/grants/grants-agreement/view'
                render={()=><GrantAgreementConfirmation isGrantView/>}
              />
              {/* TODO : isGrantView should be removed once isGrantAgreementPayment is received from API.  */}
              <Route exact path='/grants/grant-agreement/view' render={()=><ViewGrantDetails isGrantView />} />
              <Route
                path='/grants/grant-agreement'
                component={GrantAgreementFlow}
              />
              <Route
                exact
                path='/ViewGrantAgreement'
                component={ViewGrantAgreement}
              />

              <Route
                exact
                path='/investments/exchange-activity'
                component={ViewInvestmentExchangeActivity}
              />
            
              <Route
                path='/open-an-additional-account/confirm/'
                component={AccountCreated}
                exact
              />
              <Route
                path='/open-an-additional-account/contribute-later/'
                component={ContributeLater}
                exact
              />
              <Route
                path='/contributions/make-a-contribution'
                component={MakeAContribution}
                exact
              />
              <Route
                path='/contributions/make-a-contribution/investment-allocation'
                component={MakeAContribution}
                exact
              />
              <Route
                path='/contributions/make-a-contribution/review'
                component={MakeAContribution}
                exact
              />
              <Route
                path='/contributions/make-a-contribution/funding-instructions'
                component={MakeAContribution}
                exact
              />
              <Route
                path='/contributions/make-a-contribution/confirmation'
                component={ContributionConfirmation}
                exact
              />
              <Route path='/messages' component={MessagesPage} exact />
              <Route path='/my-account/my-documents' component={DocumentCentre} exact />
              <Route
                path='/contributions/activity'
                component={ContributionActivity}
                exact
              />
              <Route
                path='/contributions/activity/view'
                component={ViewContribution}
                exact
              />
              <Route path='/my-profile/edit' component={EditProfile} exact />
              <Route path='/my-account/invite-interested-parties' component={InviteParties} exact />
              <Route
                exact
                path='/contributions'
                component={ContributionsDashboard}
              />
              <Route
                exact
                path='/grants'
                component={GrantsDashboard}
              />
              <Route                               
                path="/csr/:pageName"
                component={ isGeminiUser() ? CsrMainComponent: NotFoundComponent}
              />

              <Route
                exact
                path="/view-grant-details/:grantId"
                component={ViewGrantDetails}
              />

              <Route
                exact
                path='/financialadvisor'
                component={FinancialAdvisor}
              />

              <Route path='/grants/activity/view' component={ViewGrantDetails} />
              <Route exact path='/grants/how-it-works' component={HowItWorks} />
              
              <Route
                exact
                path='/view-edit-tiff-from/:id/:type'
                component={ViewAndEditTiffFrom}
              />
              <Route
                exact
                path='/view-edit-tiff-into/:id/:type'
                component={ViewAndEditTiffInto}
              />

              <Route
                exact
                path='/tiff/recommend-an-exchange-form'
                component={TiffNotEligibleForm}
              />
              <Route path='/edit-tiff' component={EditTIFF} />
              <Route exact path='/AssetheldMF' component={AssetheldMF} />
              <Route exact path='/AssetOutsideMF' component={AssetOutsideMF} />
              <Route
                exact
                path='/AssetheldSecurity'
                component={AssetheldSecurity}
              />
              <Route
                exact
                path='/AssetheldSecuritySLOA'
                component={AssetheldSecuritySLOA}
              />
              <Route
                exact
                path='/AssetheldMFSLOA'
                component={AssetheldMFSLOA}
              />
              <Route
                exact
                path='/AssetsOutsideSecurity'
                component={AssetsOutsideSecurity}
              />
              <Route
                exact
                path='/FundingInstructionss'
                component={FundingInstructionss}
              />
              <Route
                exact
                path='/StockCertificate'
                component={StockCertificate}
              />
              <Route exact path='/Wire' component={Wire} />
              <Route exact path='/Check' component={Check} />
              <Route exact path='/grants/find-charity' component={FindCharity} />
              <Route exact path='*' component={NotFoundComponent} />
            </Switch>
          </Router>
        </RoutesContainer>
      </>
    );
  }
}


export default Routes;
